import { testSessionSchema } from '../persistence/sessionSchema';
import { QUESTION_IDS } from '../../types/ids';
import type { TestSession } from '../../types/session';

export type SessionValidationResult =
  | { valid: true; session: TestSession }
  | { valid: false; reason: 'structure' | 'schema_version' | 'scoring_version' };

/**
 * Prüft eine (z. B. aus localStorage geladene) Session auf strukturelle Gültigkeit und
 * passende Versionen (Abschnitt 28.5, ERR-004). Ungültige oder veraltete Sessions werden
 * sicher verworfen statt stillschweigend weiterverwendet.
 */
export function validateSession(
  raw: unknown,
  expected: { schemaVersion: string; scoringVersion: string },
): SessionValidationResult {
  const parsed = testSessionSchema.safeParse(raw);
  if (!parsed.success) {
    return { valid: false, reason: 'structure' };
  }
  if (parsed.data.schemaVersion !== expected.schemaVersion) {
    return { valid: false, reason: 'schema_version' };
  }
  if (parsed.data.scoringVersion !== expected.scoringVersion) {
    return { valid: false, reason: 'scoring_version' };
  }
  return { valid: true, session: parsed.data as TestSession };
}

export function isAllQuestionsAnswered(session: TestSession): boolean {
  return QUESTION_IDS.every((id) => session.answers[id] !== undefined);
}
